import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";

const SECTIONS = [
  {
    title: "Information We Collect",
    body: [
      "When you contact us through the contact form on this website, we collect the information you choose to share with us: your name, email address, phone number, the subject of your enquiry and the content of your message.",
      "We collect only the information necessary to respond to your enquiry. We do not ask for or store sensitive personal information through this website.",
    ],
  },
  {
    title: "How We Use Your Information",
    body: [
      "The information you share through the contact form is used solely to respond to your questions, suggestions or requests, and to communicate with you about Nurturing Happiness where you have asked us to do so.",
      "We do not sell, rent or share your personal information with third parties for their marketing purposes.",
    ],
  },
  {
    title: "Website Analytics",
    body: [
      "Like many websites, basic analytics may be used to understand how visitors use the site — for example, which pages are visited and how the site performs. This information is used in aggregate to improve the website and is not used to personally identify you.",
    ],
  },
  {
    title: "Cookies",
    body: [
      "This website may use simple cookies or similar technologies that help the site function properly and, where analytics are used, understand general usage patterns. You can control or disable cookies through your browser settings. Disabling cookies should not prevent you from reading the content of this website.",
    ],
  },
  {
    title: "Data Security",
    body: [
      "We take reasonable care to protect the information shared with us through this website. Messages submitted through the contact form are stored securely and access is limited to the Nurturing Happiness team.",
      "Please remember that no method of transmission over the internet is completely secure, so avoid sharing highly sensitive personal information through the contact form.",
    ],
  },
  {
    title: "Contact Requests",
    body: [
      "When you submit the contact form, your message is delivered to the Nurturing Happiness team by email and stored so that we can follow up with you. We use your contact details only to respond to your request.",
    ],
  },
  {
    title: "Your Rights",
    body: [
      "You may contact us at any time to ask what information we hold about you, to correct it, or to request that we delete it. We will do our best to respond to such requests promptly.",
    ],
  },
  {
    title: "Changes to This Policy",
    body: [
      "We may update this Privacy Policy from time to time to reflect changes in the website or in how we handle information. Any updates will be published on this page.",
    ],
  },
  {
    title: "Contact Us",
    body: [
      "If you have any questions about this Privacy Policy or how your information is handled, please contact us:",
    ],
    contact: true,
  },
];

export default function Privacy() {
  return (
    <>
      <SEO
        title="Privacy Policy | Nurturing Happiness"
        description="How Nurturing Happiness collects, uses and protects information shared through this website."
      />
      <section data-testid="privacy-page" className="paper-texture py-20 md:py-24">
        <div className="mx-auto max-w-3xl px-6">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.25em] text-nh-green">Legal</p>
            <h1 className="mt-3 font-heading text-4xl font-bold tracking-tight text-nh-ink sm:text-5xl">
              Privacy Policy
            </h1>
            <p className="mt-4 text-sm text-nh-muted">Last updated: July 2026</p>
            <p className="mt-6 text-base leading-relaxed text-nh-muted md:text-lg">
              Nurturing Happiness respects your privacy. This policy explains, in plain language,
              what information may be collected through this website and how it is used.
            </p>
          </Reveal>

          <div className="mt-12 space-y-10">
            {SECTIONS.map((s) => (
              <Reveal key={s.title}>
                <section>
                  <h2 className="font-heading text-xl font-bold text-nh-deep sm:text-2xl">{s.title}</h2>
                  {s.body.map((p, i) => (
                    <p key={i} className="mt-3 text-[15px] leading-relaxed text-nh-body md:text-base">
                      {p}
                    </p>
                  ))}
                  {s.contact && (
                    <div className="mt-4 rounded-2xl bg-nh-mint p-6 text-[15px] leading-relaxed text-nh-body">
                      <p className="font-semibold text-nh-deep">Nurturing Happiness</p>
                      <p>2nd Floor, Nishant Tower, MG Road, Akola, Maharashtra – 444001, India</p>
                      <p>
                        Phone:{" "}
                        <a href="tel:+919921193939" className="font-medium text-nh-green hover:underline">
                          +91 99211 93939
                        </a>
                      </p>
                      <p>
                        Email:{" "}
                        <a
                          href="mailto:nurturinghappiness2@gmail.com"
                          className="break-all font-medium text-nh-green hover:underline"
                        >
                          nurturinghappiness2@gmail.com
                        </a>
                      </p>
                    </div>
                  )}
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
